import { type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'contactMedewerkers',
    path: 'medewerkers',
    meta: { title: 'Medewerkers' },
    component: () => import('../contact/paginas/ContactMedewerkers.vue'),
  },
  {
    name: 'contactVragen',
    path: 'vragen',
    meta: { title: 'Veelgestelde vragen' },
    component: () => import('../contact/paginas/ContactVragen.vue'),
  },
  {
    name: 'contactPolisvoorwaarden',
    path: 'polisvoorwaarden',
    meta: { title: 'Polisvoorwaarden' },
    component: () => import('../contact/paginas/ContactPolisvoorwaarden.vue'),
  },
  {
    name: 'contactVerzekeringskaarten',
    path: 'verzekeringskaarten',
    meta: { title: 'Verzekeringskaarten' },
    component: () => import('../contact/paginas/ContactVerzekeringskaarten.vue'),
  },
  {
    name: 'contactHerstellers',
    path: 'herstellers',
    meta: { title: 'Herstellers en schade expertise' },
    component: () => import('../contact/paginas/ContactHerstellers.vue'),
  },
  {
    name: 'contactDownloads',
    path: 'downloads',
    meta: { title: 'Downloads' },
    component: () => import('../contact/paginas/ContactDownloads.vue'),
  },
];

export default routes;
